import { render } from "./Homologation.vue?vue&type=template&id=2fd1a918"
import script from "./Homologation.vue?vue&type=script&lang=js"
export * from "./Homologation.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__